export var version = "bignumber/5.0.1";